export type CapitalizeMode = 'first' | 'words' | 'upper' | 'lower' | 'sentence';

export class TextUtils {
  static capitalize(value: string, mode: CapitalizeMode = 'first'): string {
    if (!value) return '';

    value = value.trim();

    switch (mode) {
      // 🔠 Todo en MAYÚSCULAS
      case 'upper':
        return value.toLocaleUpperCase('es-ES');

      // 🔡 Todo en minúsculas
      case 'lower':
        return value.toLocaleLowerCase('es-ES');

      // 📝 Solo la primera letra de toda la frase
      case 'first':
        return value.charAt(0).toLocaleUpperCase('es-ES') + value.slice(1).toLocaleLowerCase('es-ES');

      // 🏷️ Primera letra de cada palabra
      case 'words':
        return value
          .toLocaleLowerCase('es-ES')
          .split(/\s+/) // soporta múltiples espacios
          .map(word =>
            word.length > 0
              ? word.charAt(0).toLocaleUpperCase('es-ES') + word.slice(1)
              : ''
          )
          .join(' ');

      // 📖 Capitalizar como oración (solo primera letra, resto intacto)
      case 'sentence':
        return value.charAt(0).toLocaleUpperCase('es-ES') + value.slice(1);

      // Default → primera letra
      default:
        return value.charAt(0).toLocaleUpperCase('es-ES') + value.slice(1);
    }
  }
}
